import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
  MODEL_FORMAT_OUTPUT,
  POLYGON_TYPE,
  POLYCOUNT_MODE,
  MATERIAL,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": MODEL_ID.MESHY_TEXT_TO_3D_PRO,
  "provider": PROVIDER.MESHY,
  "action": ACTION.TEXT_TO_3D,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "prompt": {
        "type": "string",
        "minLength": 1,
        "maxLength": 800,
      },
      "polygon_type": {
        "type": "string",
        "enum": [POLYGON_TYPE.TRIANGLE, POLYGON_TYPE.QUADRILATERAL],
        "default": POLYGON_TYPE.TRIANGLE,
      },
      "target_polycount": {
        "type": "integer",
        "minimum": 10000,
        "maximum": 300000,
        "default": 150000,
      },
      "material": {
        "type": "string",
        "enum": [MATERIAL.GEOMETRY_ONLY, MATERIAL.BASIC, MATERIAL.PBR],
        "default": MATERIAL.BASIC,
      },
      "polycount_mode": {
        "type": "string",
        "enum": [POLYCOUNT_MODE.TARGET, POLYCOUNT_MODE.UNLIMITED],
        "default": POLYCOUNT_MODE.TARGET,
      },
    },
    "required": ["prompt"],
    "allOf": [
      {
        "if": {
          "properties": { "material": { "enum": [MATERIAL.GEOMETRY_ONLY, MATERIAL.BASIC, MATERIAL.PBR] } },
          "required": ["material"],
        },
        "then": false,
      },
      {
        "if": {
          "properties": { "polygon_type": { "const": POLYGON_TYPE.TRIANGLE } },
          "required": ["polygon_type"],
        },
        "then": {
          "properties": {
            "model_format_output": { "const": MODEL_FORMAT_OUTPUT.GLB },
          },
        },
      },
      {
        "if": {
          "properties": { "polygon_type": { "const": POLYGON_TYPE.QUADRILATERAL } },
          "required": ["polygon_type"],
        },
        "then": {
          "properties": {
            "model_format_output": { "const": MODEL_FORMAT_OUTPUT.FBX },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.GEOMETRY_ONLY } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "geometry_only": { "const": true },
            "enable_pbr": { "const": false },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.BASIC } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "geometry_only": { "const": false },
            "enable_pbr": { "const": false },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.PBR } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "geometry_only": { "const": false },
            "enable_pbr": { "const": true },
          },
        },
      },
    ],
  },
  "ui_schema": {},
  "keyToConvert": [
    { "from": "polygon_type", "to": "topology" },
  ],
  "active_if": {
    "properties": {
      "smart_low_poly": { "const": false },
    },
  },
}
